import AuthenticateDomain from './AuthenticateDomain';

export default AuthenticateDomain;
